export const environment = {
    production: false,
    apiUrl: 'https://adp.dowino.com',
};
